import Previews from './Previews.vue';
import PreviewQuestion from './PreviewQuestion.vue';
import PreviewSurvey from './PreviewSurvey.vue';
import PreviewPrice from './PreviewPrice.vue';

export default Previews;
export {PreviewQuestion, PreviewSurvey, PreviewPrice};
